import React from 'react';
import { usePWAInstall } from './usePWAInstall';

const PWAInstallButton = () => {
  const { installed, triggerInstall } = usePWAInstall();

  if (installed) return null;

  return (
    <button
      data-testid="svd-install-btn"
      onClick={triggerInstall}
      type="button"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 14,
        background: 'linear-gradient(135deg, #B088D4 0%, #7851A9 50%, #5B2D8E 100%)',
        color: '#fff',
        textDecoration: 'none',
        padding: '14px 22px',
        borderRadius: 16,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        boxShadow: '0 8px 24px rgba(120, 81, 169, 0.35)',
        transition: 'transform .2s, box-shadow .2s',
        cursor: 'pointer',
        border: 'none',
        userSelect: 'none',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 14px 32px rgba(120, 81, 169, 0.5)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(120, 81, 169, 0.35)';
      }}
    >
      <span style={{
        width: 56, height: 56,
        background: '#fff',
        borderRadius: 12,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: 'inset 0 1px 2px rgba(91,45,142,0.15)',
        flexShrink: 0,
      }}>
        <img
          alt="Spee'V'Dee"
          src="/logo.png"
          style={{ width: 48, height: 48, display: 'block' }}
        />
      </span>
      <span style={{
        display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.15,
      }}>
        <span style={{ fontSize: 11, opacity: 0.85, letterSpacing: 0.5, textTransform: 'uppercase' }}>
          Install
        </span>
        <span style={{ fontSize: 18, fontWeight: 800, marginTop: 2 }}>
          Spee'V'Dee
        </span>
      </span>
    </button>
  );
};

export default PWAInstallButton;
